import { Import } from './Import';
import * as Moment from 'moment';

export class Lastgang {

    protected data: any[] = [];
    protected dataColumns: any[] = [];
    protected dataUnits: any[] = [];
    protected fields: any;
    protected FileTool: any;
    protected indexData: number;
    protected indexDate: number = null;
    protected indexDatetime: number = null;
    protected indexTime: number = null;
    protected indexValues: number[] = [];
    protected sheet: string;
    private readonly units: any = {
        w: { name: 'W' },
        kw: { name: 'kW' },
        mw: { name: 'mW' },
        wh: { name: 'Wh' },
        kwh: { name: 'kWh' },
        mwh: { name: 'mWh' },
        kvar: { name: 'kVAr' }
    };

    constructor(data: any, config: any) {
        this.FileTool = new Import(data);
        this.init(this.getConfig(config));
        this.setData();
    }

    protected getConfig(config: any): void {
        if (typeof config === 'string') {
            try {
                config = JSON.parse(config);
            } catch (error) {
                console.log(error.message);
            }
        } else if (typeof config === 'object') {
            config = { ...config };
        }

        return config || {};
    }

    public getColumns(): string[] {
        return this.dataColumns;
    }

    public getData(): any[] {
        return this.data;
    }

    public static getDate(value: number | string): number {
        if (typeof value === 'number') {
            const moment: any = Moment.unix(Math.ceil((value - (25567 + 2)) * 86400));
            // const moment: any = Moment.unix((value - (25567 + 2)) * 86400);
            return +moment - (+moment.utcOffset() * 60 * 1000);
        } else if (typeof value === 'string') {
            const format: string = this.geDateFormat(value);
            const moment: any = format ? Moment(value, format, true) : null;
            return (moment !== null && moment.isValid()) ? +moment : null;
        }

        return null;
    }

    protected static geDateFormat(value: number | string): string {
        switch ((value || '').toString().length) {
            case 10:
                return 'DD.MM.YYYY';
            case 16:
                return 'DD.MM.YYYY HH:mm';
            case 19:
                return 'DD.MM.YYYY HH:mm:ss';
            default:
                return null;
        }
    }

    public static getTime(time: number | string, date?: number | string): number {
        if (typeof time === 'number') {
            return time * 86400 * 1000;
        } else if (typeof time === 'string') {
            const dateFormat: string = this.geDateFormat(date);
            const timeFormat: string = this.getTimeFormat(time);
            const moment: any = dateFormat && timeFormat
                ? Moment(`${date} ${time}`, `${dateFormat} ${timeFormat}`, true)
                : (timeFormat ? Moment(time, timeFormat, true) : null);
            return moment !== null && moment.isValid()
                ? +moment - +moment.hour(0).minute(0).second(0).millisecond(0) : null;
        }

        return null;
    }

    protected static getTimeFormat(value: string): string {
        switch ((value || '').toString().length) {
            case 5:
                return 'HH:mm';
            case 8:
                return 'HH:mm:ss';
            default:
                return null;
        }
    }

    public getUnits(): any[] {
        return this.dataUnits;
    }

    protected init(config: any): void {
        this.fields = config.fields || {};
        this.indexData = typeof config.indexSheetData === 'number' ? config.indexSheetData : null;
        this.sheet = typeof config.sheet === 'string' ? config.sheet : null;

        Object.keys(this.fields).forEach((index: string) => {
            switch (this.fields[index].type || null) {
                case 'value':
                    const key: string = this.fields[index].unit || null;
                    const name: string = this.fields[index].name || null;
                    const unit: any = this.units[key] || null;
                    this.dataColumns.push(name ? { name } : null);
                    this.dataUnits.push(unit ? { ...unit, key } : null);
                    this.indexValues.push(+index);
                    break;
                case 'date':
                    this.indexDate = +index;
                    break;
                case 'datetime':
                    this.indexDatetime = +index;
                    break;
                case 'time':
                    this.indexTime = +index;
                    break;
            }
        });
    }

    private setData(): void {
        if (
            !this.indexValues.length || this.indexData === null
            || (this.indexDatetime === null && this.indexDate === null)
            || (this.indexDatetime === null && (this.indexDate === null || this.indexTime === null))
        ) {
            return;
        }

        this.FileTool.getSheetDataByName(this.sheet).forEach((data: any[], index: number) => {
            if (index < this.indexData || !(data || []).length) {
                return;
            }
            const date: number = Lastgang.getDate(data[this.indexDatetime] || data[this.indexDate]);
            const time: number = Lastgang.getTime(data[this.indexTime], data[this.indexDate]);
            let time2: number = time;

            if (typeof data[this.indexTime] === 'number' && typeof data[this.indexDate] === 'number') {
                const date2: number = Math.ceil((data[this.indexDate] - (25567 + 2)) * 86400);
                const moment: any = Moment.unix(date2).hour(0).minute(0).second(0).millisecond(0);
                const moment2: any = Moment.unix((+moment + time) / 1000);
                time2 = time - ((moment2.utcOffset() - moment.utcOffset()) * 60 * 1000);
            }
            const moment: any = Moment.unix((date + time2) / 1000);
            const values: any[] = this.indexValues.map((index2: number) => typeof data[index2] !== 'undefined' ? data[index2] : null);

            if (!date || (this.indexTime !== null && time2 === null) || !moment.isValid()) {
                return;
            }
            this.data.push({ datetime: moment.toDate(), values });
        });
    }
}
